import React, { ReactElement } from 'react';

export default function AddToDictionaryIcon(): ReactElement {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="20.9">
            <g fill="#707070">
                <path d="M2.4 2.7A2.4 2.4 0 000 5.1v13.6A2.3 2.3 0 002.4 21H15v-.8H2.4a1.5 1.5 0 01-1.6-1.4 1.5 1.5 0 011.6-1.3H15V2.7zm0 .8h11.9v13h-12a2.5 2.5 0 00-1.5.6v-12a1.6 1.6 0 011.6-1.6zm2.9 3.6l-2.1 6v.3H4v-.1l.3-1h2.9l.3 1v.1h.8v-.2L6.3 7zm.4 1L7 11.4H4.6zm4.6.5a1.2 1.2 0 00-.9.4 1.2 1.2 0 00-.3.8h.8a.4.4 0 010-.3.4.4 0 01.4 0 .3.3 0 01.3 0 .8.8 0 010 .5v.3a1.2 1.2 0 00-.3 0h-.4a1.2 1.2 0 00-1.2 1.1v.8a1.2 1.2 0 001.2 1.2h.4a1.2 1.2 0 00.8-.3 1.2 1.2 0 00.8.3v-.8a.4.4 0 01-.4-.4V10a1.6 1.6 0 00-.3-.9 1.1 1.1 0 00-1-.5zM9.9 11h.4a.4.4 0 01.4.4v.8a.4.4 0 01-.4.4h-.4a.4.4 0 01-.4-.4v-.8a.4.4 0 01.4-.4z" />
                <path d="M15 6.5h-2v-2h-2v-2h2v-2h2v2h2v2h-2v2z" />
                <path
                    fill="#fff"
                    d="M14.5 6V4h2V3h-2V1h-1v2h-2v1h2v2h1m1 1h-3V5h-2V2h2V0h3v2h2v3h-2v2z"
                />
            </g>
        </svg>
    );
}
